import { render, staticRenderFns } from "./Selftest.vue?vue&type=template&id=a9db5f0a"
import script from "./Selftest.vue?vue&type=script&lang=js"
export * from "./Selftest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports